export { getElementInputValue } from './serializationUtils';
export { serializeDocument } from './serializeDocument';
export { serializeNodeWithId } from './serializeNode';
export { serializeAttribute } from './serializeAttribute';
export { createSerializationScope } from './serializationScope';
export { createSerializationStats, updateSerializationStats, aggregateSerializationStats } from './serializationStats';
//# sourceMappingURL=index.js.map